import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCategory'
})
export class FilterCategoryPipe implements PipeTransform {

  transform(events: any[], category: string | null | undefined): any[] {
    if (!events || !category) {
      return events;
    } else {
      return events.filter(event => {
        return event.categories.find((c: any) => c.toLowerCase() == category.toLowerCase()) != undefined;
      });
    }
  }
}
